module.exports = __webpack_public_path__ + "img/MSR.28a0a9ef.svg";